import { msg } from '@gonfalon/messages/msg';
import { Button } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';

import './styles.scss';

type OmnibarTriggerProps = {
  onClick: () => void;
  className?: string;
  variant?: 'minimal' | 'default' | 'primary';
  size?: 'small' | 'medium' | 'large';
  showShortcut?: boolean;
};

export function OmnibarTrigger({
  onClick,
  className,
  variant = 'minimal',
  size = 'medium',
  showShortcut = true,
}: OmnibarTriggerProps) {
  const triggerClasses = ['omnibar-trigger', showShortcut && 'omnibar-trigger--with-shortcut', className]
    .filter(Boolean)
    .join(' ');

  return (
    <Button variant={variant} size={size} onClick={onClick} className={triggerClasses}>
      <Icon name="search" slot="start-icon" />
      <span className="omnibar-trigger__text">{msg('vital.accountSearch.trigger')}</span>
      {showShortcut && (
        <div className="omnibar-trigger__shortcut">
          <span>⌘</span>
          <span>K</span>
        </div>
      )}
    </Button>
  );
}

export default OmnibarTrigger;
